export const skillCategories = [
  {
    category: "Languages",
    skills: ["Go", "Python", "JavaScript", "TypeScript", "Java", "SQL"]
  },
  {
    category: "Backend & Systems",
    skills: ["Node.js", "Express.js", "Gin", "REST APIs", "gRPC", "Microservices", "GraphQL"]
  },
  {
    category: "Frontend",
    skills: ["React.js", "Next.js", "Redux", "Tailwind CSS", "HTML5", "CSS3"]
  },
  {
    category: "Databases & Caching",
    skills: ["PostgreSQL", "MongoDB", "MySQL", "Redis", "Firebase"]
  },
  {
    category: "Cloud & DevOps",
    skills: ["GCP", "AWS", "Azure", "Docker", "Kubernetes", "Terraform", "CI/CD", "Prometheus", "Grafana"]
  },
  {
    category: "AI & LLM",
    skills: ["OpenAI API", "LangChain", "RAG", "Prompt Engineering", "LLM Agents", "PyTorch", "scikit-learn"]
  }
]

export const typingAnimationTexts = [
  'Gen AI Products',
  'AI Applications',
  'Go Backend Systems',
  'Cloud-Native Microservices',
  'Full-Stack Products',
  'Distributed Systems'
]
